import React, { useContext } from 'react';
import {
  number,
  oneOfType,
  shape,
  string
} from 'prop-types';
import {
  Checkbox,
  SelectionControlLabel
} from '@one-thd/sui-atomic-components';
import { CalculatorContext } from '../../CalculatorProvider';

const fixedValue = (value) => {
  return (Math.round(value * 100) / 100).toFixed(2);
};

const numberWithComma = (value) => {
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

const checkBulkPrice = (quantity, pricing) => {
  const bulkPrice = pricing?.alternate?.bulk?.value;
  const bulkPriceThresholdQty = pricing?.alternate?.bulk?.thresholdQuantity;
  if (bulkPrice && bulkPriceThresholdQty && quantity >= bulkPriceThresholdQty) {
    return bulkPrice;
  }

  const price = pricing?.value;
  return price;
};

export const Results = ({
  uom,
  unitsPerCase,
  caseUnitOfMeasure,
  pricing
}) => {
  const { calculate, setCalculate } = useContext(CalculatorContext);
  const { addAdditionalCoverage, quantity } = calculate;

  if (!uom || !quantity) {
    return null;
  }

  const onAdditionalChange = (event) => {
    setCalculate({
      ...calculate,
      addAdditionalCoverage: event.target.checked,
      changesAwaitingLocalStorage: true
    });
  };

  const newPrice = checkBulkPrice(quantity, pricing);
  const totalPrice = +quantity * +newPrice;
  const updatedTotalPrice = fixedValue(totalPrice);
  const totalCoverage = +quantity * +unitsPerCase;
  const measureUnit = quantity && parseInt(quantity, 10) > 1 ? uom + 's' : uom;
  return (
    <div className={'ui-flex sui-flex-wrap sui-relative sui-bg-primary sui-border-solid sui-border-1 '
      + 'sui-border-primary sui-p-2 sui-mr-3 max-lg:sui-mr-0 max-lg:sui-w-full'}
    >
      <div className="sui-float-left sui-p-2">
        <div className="sui-font-bold sui-text-3xl">{quantity} {measureUnit}</div>
        <div> will cover {fixedValue(totalCoverage)} {caseUnitOfMeasure}</div>
      </div>
      <div className="sui-flex sui-flex-col sui-items-end sui-float-right sui-p-2">
        <div className="sui-font-bold sui-text-3xl"> ${numberWithComma(updatedTotalPrice)} </div>
        <div>Est. Total</div>
      </div>
      <div className="sui-clear-both sui-p-2">
        <SelectionControlLabel
          value="additional-coverage"
          checked={addAdditionalCoverage}
          label="Include an extra 10% to cover potential waste and breaks"
        >
          <Checkbox
            onChange={onAdditionalChange}
            inputAttributes={{ 'aria-label': 'controlled' }}
          />
        </SelectionControlLabel>
      </div>
    </div>
  );
};

Results.propTypes = {
  caseUnitOfMeasure: string,
  pricing: shape({
    bulkPrice: number,
    bulkPriceThresholdQty: number
  }),
  unitsPerCase: oneOfType([string, number]),
  uom: string
};

Results.defaultProps = {
  caseUnitOfMeasure: '',
  pricing: {},
  unitsPerCase: '',
  uom: ''
};